import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {
  CartDeliveryList,
  CartDeliveryRes,
  GoponRes2,
  OrderDetailsRes,
  SelectedBranchDeliveryObj,
} from '@app/core/models';
import {AddToCartReq, CartRes, CheckOutReq, CheckOutRes,} from '@app/core/models/cart/cart.models';
import {environment} from '@environments/environment';
import {BehaviorSubject, Observable, shareReplay, take} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CartService {
  private baseUrl = environment.API_BASE_URL + 'Cart/';
  private addToCartUrl = this.baseUrl + 'AddToCart';
  private getCartDetailsUrl = this.baseUrl + 'GetCartDetails';
  private removeFromCartUrl = this.baseUrl + 'RemoveFromCart';
  private isCartItemsValidUrl = this.baseUrl + 'IsCartItemsValid';
  private isCartAddressValidUrl = this.baseUrl + 'IsCartAddressValid';
  private applyCouponCodeUrl = this.baseUrl + 'ApplyCouponCode';
  private removeCouponCodeUrl = this.baseUrl + 'RemoveCouponCode';
  private checkOutUrl = this.baseUrl + 'CheckOut';
  private confirmPaymentUrl = this.baseUrl + 'TabCallbackWebsite';
  private getCartDeliveryList =this.baseUrl + 'GetCartDeliveryList';
  private setCartDelivery =this.baseUrl + 'SetCartDelivery';
  private opeCart$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  constructor(private readonly http: HttpClient) {}

  get openCartStatus() {
    return this.opeCart$;
  }

  openCartSide(): void {
    this.opeCart$.next(true);
  }
  closeCartSide(): void {
    this.opeCart$.next(false);
  }

  addToUserCart(body: AddToCartReq): Observable<CartRes> {
    return this.http
      .post<CartRes>(this.addToCartUrl, body)
      .pipe(shareReplay(1), take(1));
  }
  getCartDetails(cartId: number): Observable<CartRes> {
    return this.http.get<CartRes>(this.getCartDetailsUrl, {
      params: { cartId },
    });
  }
  removeFromCart(cartId: number, itemId: number): Observable<CartRes> {
    return this.http
      .delete<CartRes>(this.removeFromCartUrl, { params: { cartId, itemId } })
      .pipe(shareReplay(1), take(1));
  }
  isCartItemsValid(cartId: number, branchId: number): Observable<CartRes> {
    return this.http
      .post<CartRes>(this.isCartItemsValidUrl, { cartId, branchId })
      .pipe(shareReplay(1), take(1));
  }
  isCartAddressValid(
    cartId: number,
    branchId: number,
    addressId: number
  ): Observable<CartRes> {
    return this.http
      .post<CartRes>(this.isCartAddressValidUrl, {
        cartId,
        branchId,
        addressId,
      })
      .pipe(shareReplay(1), take(1));
  }

  applyCouponCode(cartId: number, CouponCode: string): Observable<CartRes> {
    return this.http
      .put<CartRes>(this.applyCouponCodeUrl, {
        //cartId,
        CouponCode,
      })
      .pipe(shareReplay(1), take(1));
  }
  removeCouponCode(cartId: number, CouponCode: string): Observable<CartRes> {
    return this.http
      .delete<CartRes>(this.removeCouponCodeUrl, {
        params: {
          //cartId,
          CouponCode },
      })
      .pipe(shareReplay(1), take(1));
  }
  checkOut(body: CheckOutReq): Observable<CheckOutRes> {
    body.CallbackURL = environment.appUrl + 'thank-you';
    return this.http
      .post<CheckOutRes>(this.checkOutUrl, body)
      .pipe(shareReplay(1), take(1));
  }
  confirmPayment(tapId: string): Observable<OrderDetailsRes> {
    return this.http.post<OrderDetailsRes>(this.confirmPaymentUrl, { tapId });
  }
  GetCartDeliveryList():Observable<GoponRes2<{ Data:CartDeliveryList[] }>>{
    return this.http.get<GoponRes2<{ Data:CartDeliveryList[] }>>(this.getCartDeliveryList)
  }
  SetCartDelivery(body:SelectedBranchDeliveryObj):Observable<any>{
    return this.http.post<any>(this.setCartDelivery,body)
  }
}
